import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { GeneralName } from "@peculiar/asn1-x509";
import { id_ntQWAC } from "./oids";
export const id_WebGDPR = `${id_ntQWAC}.7`;
let WebGDPR = class WebGDPR {
    constructor(params = {}) {
        this.assessmentAuthority = new GeneralName();
        this.assessmentRef = new GeneralName();
        this.assessmentLocation = new GeneralName();
        this.dataStorageTerritory = "";
        this.description = "";
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: GeneralName, context: 0 })
], WebGDPR.prototype, "assessmentAuthority", void 0);
__decorate([
    AsnProp({ type: GeneralName, context: 1 })
], WebGDPR.prototype, "assessmentRef", void 0);
__decorate([
    AsnProp({ type: GeneralName, context: 2 })
], WebGDPR.prototype, "assessmentLocation", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString, context: 3 })
], WebGDPR.prototype, "dataStorageTerritory", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String, context: 4 })
], WebGDPR.prototype, "description", void 0);
WebGDPR = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], WebGDPR);
export { WebGDPR };
